"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var SliderWrapper = _styledComponents.default.div.withConfig({
  displayName: "SliderWrapper",
  componentId: "sc-1rx6grx-0"
})(["height:100%;position:relative;padding:", ";margin:", ";"], function (props) {
  return props.padding || '0px 0px';
}, function (props) {
  return props.margin || '0px 0px';
});
var _default = SliderWrapper;
exports.default = _default;